module.exports = __webpack_public_path__ + "static/media/alcomputer_sm.779d0786.png";